import {
    Validate
  } from './_formValidation';
  
  var cleanInput = (that) => {
   
    var inputPattern="0";
    if (that.value && that.value != Validate.stripProhibitedCharacters(that.value, inputPattern)) {

        var dataPattern = that.getAttribute('patterntype');
        
        if (dataPattern == "name") { 
            inputPattern = "[a-z A-Z\-']";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        if (dataPattern == "address") { 
            inputPattern = "[\- a-z A-Z 0-9\#\/]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        //City
        if (dataPattern == "city") {
            inputPattern = "[a-z A-Z\-']";
            that.value  = Validate.stripProhibitedCharacters(that.value, inputPattern);        
        }
        //Email
        if (dataPattern == "email") {
            inputPattern = "[^<>{#\`~$\&^+=<>\"|%}';\u20ac\u00a3\u00a5]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        //Password
        if (dataPattern == "password") {
            inputPattern = "[^\\\\<>{#`~$&^+=\"|%}';\u20ac\u00a3\u00a5]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        
        if (dataPattern == "shareMessage") { 
            inputPattern = "[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\?\\.\\,\\[\\]\\#\\\"' ]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        if (dataPattern == "giftMessage") { 
            inputPattern = "[a-zA-Z0-9\\!\\@\\*\\(\\)\\:\\?\\.\\,\\#\\' \\\-\\$\\%\\&\\+\/]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
        if (dataPattern == "searchField") { 
            inputPattern= "[\\w\\d\\!\\@\\_\\*\\(\\)\\-\\:\\?\\.\\,\\\\\\/\\#\\\"\\Ø\\ø\\&\\+' ]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        } 
        if (dataPattern == "regNum") { 
            inputPattern = "[0-9]";
            that.value = Validate.stripProhibitedCharacters(that.value, inputPattern);
        }
    } 
   }
  
  
  //This method binds to the INPUT of all inputs and textareas and will strip any prohibited characters as the user types
  export const stripRestrictedCharFromInput = () => {
    $('input, textarea').not($(".search-input, input[type='checkbox'], input[type='radio'], #search-by-brand-filter-input")).on('keyup', function() {
        if (this.value && this.value != Validate.stripNonEnglishCharacters(this.value)) this.value = Validate.stripNonEnglishCharacters(this.value);
    });
    $('input, textarea').not($("#emailProductModal input[name='productName'], #emailProductModal input[name='productKeyword'], .search-input, input[type='email'], input[type='checkbox'], input[type='radio'], #search-by-brand-filter-input")).on('input', function() {
      let hiddenEmailModalInput = $('#emailProduct').length > 0 && $(this).attr('name') == 'productName';
      if(!hiddenEmailModalInput) cleanInput(this);
    });
    $(".search-input").on('input', function() {
        cleanInput(this);
    });
  };
  